// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export class FilesHelper {

    //#region  Private
    static #BlobTypesByExtension = {      // https://www.iana.org/assignments/media-types/media-types.xhtml#text
        'txt': 'text/plain',
        'html': 'text/html',
        'json': 'application/json',
        'csv': 'text/csv'
    }

    static #getBlobTypeByFileName(filename) {
        if (!filename)
            return null;

        var splits = filename.split('.'),
            extension = splits.length ? splits[splits.length - 1] : '';

        var blobType = this.#BlobTypesByExtension[extension] || this.#BlobTypesByExtension.txt

        return blobType
    }

    static #s2ab(s)   // need for export to Excel with SheetJS #93681
    {
        var buf = new ArrayBuffer(s.length),
            view = new Uint8Array(buf);

        for (var i = 0; i < s.length; i++)
            view[i] = s.charCodeAt(i) & 0xFF;

        return buf
    }
    //#endregion Private

    static saveFile(filename, data, blob) {
        var file = blob || new Blob([data], { type: this.#getBlobTypeByFileName(filename) });

        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        else
        { // Others
            var a = document.createElement("a"),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function ()
            {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }

    static saveExcelFile(filename, tables) {
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: filename,
            CreatedDate: new Date()
        }

        for (let tableI = 0; tableI < tables.length; tableI++)
        {
            let table = tables[tableI],
                tableData = table.Data || [],
                reportName = table.TableName ? table.TableName.substr(0, 31) : ''  // can't set sheetNames longer than 31 symb

            wb.SheetNames.push(reportName)

            var ws = XLSX.utils.aoa_to_sheet(tableData)
            wb.Sheets[reportName] = ws
        }

        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        this.saveFile(filename + '.xlsx', null, new Blob([this.#s2ab(wbout)], { type: 'application/octet-stream' }))
    }
}